export default () => ({
  items: []
});
